import { getEventDesktop } from "app/api/eventsApi";
import * as FavouriteAPI from "app/api/favouritesApi";
import type { EventType } from "app/types/eventType";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { IconArrowLeft } from "../../../../../../../../components/Icon/Icon";
import ModalEventIcons from "../EventName/components/ModalEventIcons/ModalEventIcons";
import { OnClickGraphHelper } from "../EventName/helpers/OnClickGraphHelper/OnClickGraphHelper";
import "./WidgetHeader.scss";

type Props = {
  event: EventType;
  updateUnsummarizedMarketsModalEvent: Function;
  setPositionMatrixModalEvent: Function;
  setPositionMatrixModalItem: Function;
  openPositionMatrixModal: Function;
  favouritesOnly: boolean;
  addFavouriteToList: Function;
  removeFromFavouritesList: Function;
  setEventFavourite: Function;
  fetchEventData: (...args: Array<any>) => any;
  previousRoute: string | null;
};
type State = {
  isFavourite: boolean;
}; //

class WidgetHeader extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isFavourite: this.props.event.favourite,
    };
  }

  onClickPositionMatrix = (event: any) => {
    this.props.setPositionMatrixModalEvent(event);
    this.props.setPositionMatrixModalItem(event.id);
    this.props.openPositionMatrixModal();
  };
  onClickGraph = () => {
    OnClickGraphHelper.onClickGraph(this.props.event);
  };
  // / toggling add/remove favourites by clicking favourites button
  toggleAddRemoveToFavorites = (eventId: number) => {
    const { favouritesOnly } = this.props;

    if (this.state.isFavourite === false) {
      this.props.addFavouriteToList(eventId);
      this.updateFavourite(eventId, favouritesOnly);
    } else {
      this.props.removeFromFavouritesList(eventId);
      this.updateFavourite(eventId, favouritesOnly);
    }
  };
  // update events with latest favourite status
  updateFavourite = (eventId: number, favouritesOnly: boolean) => {
    this.setState({
      isFavourite: !this.state.isFavourite,
    });
    // since web socket update not avaiable use AJAX call
    getEventDesktop(eventId, true)
      .then(eventData => {
        this.props.setEventFavourite(eventData, favouritesOnly);
        // get latest favourites from API
        FavouriteAPI.getFavouriteList();
        this.props.fetchEventData();
      })
      .catch(error => {
        throw error;
      });
  };
  componentDidUpdate = (prevProps: any, prevState: any) => {
    if (prevProps.event.favourite !== this.props.event.favourite) {
      this.setState({
        isFavourite: this.props.event.favourite,
      });
    }
  };

  onClickBack = () => {
    this.props.updateUnsummarizedMarketsModalEvent(null);
  };

  render() {
    const { event } = this.props;
    // Use previousRoute if available, otherwise fallback to /events
    const backUrl = this.props.previousRoute || "/events";
    return (
      <header className="unsummarized-markets__header">
        <Link to={backUrl} className="back-button" onClick={this.onClickBack}>
          <IconArrowLeft />
          <FormattedMessage
            tagName="span"
            id="global-events-navigation-all-events"
          />
        </Link>
        <span className="tab-icons">
          <ModalEventIcons
            event={event}
            onClickPositionMatrix={this.onClickPositionMatrix}
            toggleAddRemoveToFavorites={this.toggleAddRemoveToFavorites}
            onClickGraph={this.onClickGraph}
          />
        </span>
      </header>
    );
  }
}

const mapStateToProps = state => ({
  favouritesOnly: state.competitionListModel.favouritesOnly,
  previousRoute: state.navigationModel.previousRoute,
});

const mapDispatchToProps = dispatch => ({
  toggleMarketGraph: (eventData, runner, market) => {
    dispatch.marketDataGraphModel.openMarketGraphModal(
      eventData,
      runner,
      market
    );
  },
  setPositionMatrixModalEvent: event => {
    dispatch.positionMatrixListModel.setPositionMatrixModalEvent(event);
  },
  setPositionMatrixModalItem: (eventId: number) => {
    dispatch.positionMatrixListModel.setPositionMatrixModalItem({
      eventId: eventId,
    });
  },
  resetPositionMatrix: () => {
    dispatch.positionMatrixListModel.closePositionMatrixModal();
  },
  openPositionMatrixModal: () => {
    dispatch.positionMatrixListModel.openPositionMatrixModal();
  },
  addFavouriteToList: (eventId, callback) =>
    dispatch.favouritesListModel.addFavouriteToList({
      eventId,
      callback,
    }),
  removeFromFavouritesList: (eventId, callback) =>
    dispatch.favouritesListModel.removeFromFavouriteToList({
      eventId,
      callback,
    }),
  setEventFavourite: (event: EventType, favouritesOnly: boolean) =>
    dispatch.competitionListModel.updateEventFavouriteInCompetitionInList(
      event,
      favouritesOnly
    ),
  updateUnsummarizedMarketsModalEvent: (event: EventType) =>
    dispatch.competitionListModel.updateUnsummarizedMarketsModalEvent(event),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WidgetHeader) as any;
